import { render } from "./App.vue?vue&type=template&id=aa82be80"
const script = {}
script.render = render

export default script